import analyticPalettes from 'src/utils/analyticPalettes';


// Función helper para convertir rgb/rgba string a array
const rgbStringToArray = rgbString => {
  const match = rgbString.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d.]+)?\)/);
  if (match) {
    const r = parseInt(match[1]);
    const g = parseInt(match[2]);
    const b = parseInt(match[3]);
    const a = match[4] ? Math.round(parseFloat(match[4]) * 255) : 255;
    return [ r, g, b, a ];
  }
  return [ 0, 0, 0, 255 ];
};

const hexToRgbaArray = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [
    parseInt(result[1], 16),
    parseInt(result[2], 16),
    parseInt(result[3], 16),
    255,
  ] : [ 0, 0, 0, 255 ];
};

const paletteToTitilerColormap = (palette, steps = null) => {
  const colormap = {};
  const numColors = palette.length;
  const maxValue = 255;

  palette.forEach((item, index) => {
    const value = steps ? steps[index] : Math.round((index / (numColors - 1)) * maxValue);
    const color = item.color.startsWith('rgb')
      ? rgbStringToArray(item.color)
      : hexToRgbaArray(item.color);
    colormap[value] = color;
  });

  return colormap;
};

const titilerParams = {
  default: {
    colormap_name: 'rdylgn',
  },
  biomass: {
    colormap: paletteToTitilerColormap(analyticPalettes.biomass, [ 0, 32, 64, 96, 128, 160, 192, 224, 255 ]),
    colormap_type: 'linear',
  },
  ndvi: {
    colormap_name: 'rdylgn',
  },
  ndmi: {
    colormap_name: 'rdylbu',
  },
  ndti: {
    colormap_name: 'rdylgn',
  },
  albedo: {
    colormap_name: 'viridis',
  },
  ndwi: {
    colormap: paletteToTitilerColormap(analyticPalettes.ndwi, [ 0, 36, 73, 109, 146, 182, 219, 255 ]),
    colormap_type: 'linear',
  },
  landcover: {
    colormap: paletteToTitilerColormap(analyticPalettes.landcover, [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13 ]),
  },
  'landcover-water': {
    colormap: paletteToTitilerColormap([
      analyticPalettes.landcover[8], // Río, lago u océano (9)
      analyticPalettes.landcover[9], // Hielo y nieve (10)
    ], [ 9, 10 ]),
  },
  eii: {
    colormap: paletteToTitilerColormap(analyticPalettes.eii, [ 0, 32, 64, 96, 128, 160, 192, 224, 255 ]),
    colormap_type: 'linear',
  },
  msa: {
    colormap_name: 'rdylgn',
  },
  patches: {
    colormap: paletteToTitilerColormap(analyticPalettes.patches, [ 1, 2, 3, 4, 5, 6 ]),
  },
  // 'wetland-patches': {
  //   colormap: paletteToTitilerColormap([ analyticPalettes.patches[1] ], [ 2 ]),
  // },
  // 'grassland-patches': {
  //   colormap: paletteToTitilerColormap([ analyticPalettes.patches[2] ], [ 3 ]),
  // },
  // 'forest-patches': {
  //   colormap: paletteToTitilerColormap([ analyticPalettes.patches[3] ], [ 4 ]),
  // },
  // 'snow-patches': {
  //   colormap: paletteToTitilerColormap([ analyticPalettes.patches[4] ], [ 5 ]),
  // },
  // 'shrubland-patches': {
  //   colormap: paletteToTitilerColormap([ analyticPalettes.patches[5] ], [ 6 ]),
  // },
  gpp: {
    colormap: paletteToTitilerColormap(analyticPalettes.gpp, [ 0, 25, 51, 76, 102, 127, 153, 178, 204, 229, 255 ]),
    colormap_type: 'linear',
  },
  richness: {
    colormap_name: 'rdylgn',
  },
  'conversion-areas': {
    colormap: paletteToTitilerColormap(analyticPalettes.conversionAreas, [ 3, 4, 5, 13 ]),
  },
  'eii-reclass': {
    colormap: paletteToTitilerColormap(analyticPalettes.eiiReclass, [ 1, 2, 3, 4, 5 ]),
  },
  'natural-vegetation-proportion': {
    colormap: paletteToTitilerColormap(analyticPalettes.naturalVegetationProportion, [ 1, 2 ]),
  },
  si: {
    colormap_name: 'haline',
  },
  'rgb-drone': {
    bidx: [ 1, 2, 3 ],
    nodata: 0,
  },
};


export default titilerParams;
